module.exports = __webpack_public_path__ + "static/media/female_left.f7c4b216.jpg";